import LayerTile from "ol/layer/Tile.js";
import * as olSource from "ol/source";
import OLVectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import GeoJSON from 'ol/format/GeoJSON';
import FeatureStyles from "../config/styles";
import mapConfig from "../config/mapConfig.json";

export default {

  lrd_wrd: new OLVectorLayer({
    title: "LRD WRD",
    visible: true,
    source: new VectorSource({
      url: mapConfig.test_lrd_wrd_url,
      format: new GeoJSON(),
    }),
    style: FeatureStyles.MultiPolygon,
  }),


  gtPoints: new OLVectorLayer({
    title: "GT Points",
    visible: true,
    source: new VectorSource({
      url: "https://bhuvan-nyayavikas.nrsc.gov.in/mobile/sisdpgtmob_php/get_geojson.php",
      format: new GeoJSON(),
    }),
    style: FeatureStyles.Point,
  }),

  
  Bhuvan_sat: new LayerTile({
    title: "Bhuvan_sat",
    type: "base",
    visible: true,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms/",
      params: {
        LAYERS: "v3:state",
        TILED: true,
        VERSION: "1.1.1",
        FORMAT: "image/png",
        CRS: "EPSG:4326",
        SRS: "EPSG:4326",
      },
    }),
  }),

  Bhuvan: new LayerTile({
    title: "Bhuvan",
    type: "base",
    visible: true,
    source: new olSource.TileWMS({
      url: "https://bhuvan-vec1.nrsc.gov.in/bhuvan/gwc/service/wms/",
     
      params: {
        LAYERS: "india3",
        TILED: true,
        VERSION: "1.1.1",
        FORMAT: "image/jpeg",
        CRS: "EPSG:4326",
        SRS: "EPSG:4326",
      },
    }),
  }),

  LULC: new LayerTile({
    title: "LULC",
    visible: true,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver2/SISDP_P2/wms",     
      params: {
        LAYERS: "SISDP_P2:LULC_PHASE_II",
        TILED: true,
        VERSION: "1.1.1",
        FORMAT: "image/png",
        SRS: "EPSG:4326",
      },
    }),
  }),

  Bhuvan_satellite: new LayerTile({
    title: "Bhuvan Satellite",
    type: "base",
    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-vec1.nrsc.gov.in/bhuvan/gwc/service/wms/",
      params: {
        LAYERS: "india3",
        TILED: true,
        EXTENT: [83.323, 24.286, 88.298, 27.521],
        VERSION: "1.1.1",
        FORMAT: "image/png",
        CRS: "EPSG:4326",
        SRS: "EPSG:4326",
      },
    }),
  }),

  

  //Satellite Layer
  bhuvan_imagerySource: new LayerTile({
    title: " Satellite",
    type: "base",
    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-vec1.nrsc.gov.in/bhuvan/gwc/service/wms/",
      params: {
        LAYERS: "india3",
        TILED: true,
        EXTENT: [83.323, 24.286, 88.298, 27.521],
        VERSION: "1.1.1",
        FORMAT: "image/png",
        CRS: "EPSG:4326",
        SRS: "EPSG:4326",
      },
    }),
  }),
  //State Layer
  stateLayer: new LayerTile({
    title: "States",
    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:state",
        FORMAT: "image/png",
      },
    }),
  }),

  // District Layer
  districtLayer: new LayerTile({
    title: "Districts",
    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:district",
        FORMAT: "image/png",
      },
    }),
  }),

  //Block Layer
  blockLayer: new LayerTile({
    title: "Blocks",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:block",
        FORMAT: "image/png",
      },
    }),
  }),

  //Panchayat Layer
  panchayatLayer: new LayerTile({
    title: "Panchayat",
    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:panchayat",
        FORMAT: "image/png",
      },
    }),
  }),

  //Village Layer
  villageLayer: new LayerTile({
    title: "Village",
    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:village",
        FORMAT: "image/png",
      },
    }),
  }),

  //Cadastral Layer
  cadastralLayer: new LayerTile({
    title: "Cadastral",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:cadastral",
        FORMAT: "image/png",
      },
    }),
  }),

  //Parliament Layer
  parliamentLayer: new LayerTile({
    title: "Parliament",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:parliament",
        FORMAT: "image/png",
      },
    }),
  }),

  //Assembly Layer
  assemblyLayer: new LayerTile({
    title: "Assembly",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:assembly",
        FORMAT: "image/png",
      },
    }),
  }),

  //Infrastructure Layers
  //Rail Layer
  railLayer: new LayerTile({
    title: "Rail",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:rail",
        FORMAT: "image/png",
      },
    }),
  }),

  //Road Layer

  roadLayer: new LayerTile({
    title: "Road",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:road",
        FORMAT: "image/png",
      },
    }),
  }),

  //Hydrology Layers
  //Basin Layer

  basinLayer: new LayerTile({
    title: "Basin",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:basin",
        FORMAT: "image/png",
      },
    }),
  }),

  //SubBasin Layer
  subbasinLayer: new LayerTile({
    title: "SubBasin",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:subbasin",
        FORMAT: "image/png",
      },
    }),
  }),

  //Watershed Layer
  watershedLayer: new LayerTile({
    title: "Watershed",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:watershed",
        FORMAT: "image/png",
      },
    }),
  }),

  //Microwatershed Layer
  subwatershedLayer: new LayerTile({
    title: "Microwatershed",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:subwatershed",
        FORMAT: "image/png",
      },
    }),
  }),

  //Thematic Layers
  //LULC Layer
  lulcLayer: new LayerTile({
    title: "LULC",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:lulc",
        FORMAT: "image/png",
      },
    }),
  }),

  //Progress bar for Slope
  //Slope Layer
  slopeLayer: new LayerTile({
    title: "Slope",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:slope",
        FORMAT: "image/png",
      },
    }),
  }),

  //Drainage Layer
  drainageLayer: new LayerTile({
    title: "Drainage",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:drainage",
        FORMAT: "image/png",
      },
    }),
  }),

  //Settlement Layer
  settlementLayer: new LayerTile({
    title: "Settlement",

    visible: false,
    source: new olSource.TileWMS({
      url: "https://bhuvan-panchayat3.nrsc.gov.in/geoserver/gwc/service/wms",
      transition: 0,
      crossOrigin: "anonymous",
      params: {
        VERSION: "1.1.1",
        transparent: !0,
        LAYERS: "v3:settlement",
        FORMAT: "image/png",
      },
    }),
  }),
};
